/*
 * @Description: 所有的项目编辑都会混入这个文件，可以在此控制表单的项目。只处理维护项目
 * @Date: 2022-05-24 10:57:37
 */

import { mapState } from 'vuex';

import { makeSure as makeSureMixin } from '@/Mixin/makeSure';
import { btLoading } from '@/Mixin/btLoading';
import hasIndustry from '@/Mixin/hasIndustry';
import ocu from './occupationCertification';

import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import GenerateImage from '@/components/Common/GenerateImage';
import submitVerifyBtn from '@/components/Judge/submitVerifyBtn';
import submitResult from '@/components/Judge/submitResult';
import dicSelect from '@/components/Common/dicSelect.vue';
import submitVerifyAndNextBtn from '@/components/Judge/submitVerifyAndNextBtn';
import TmExecuteNameRule from '@/page/project-classify/src/components/form-items/tmExecuteNameRule';
import TmTargetNameRule from '@/page/project-classify/src/components/form-items/tmTargetNameRule';

// 审核人员对其可见 设置
import Reviewer from '@/page/project-classify/src/components/reviewer.vue';

import { projectV2 } from '@/api/ajax';
import { backgroundList } from '@/config/staticData';

import { deepClone, makeSure } from '@/tools/index';
import { priceFilterForTools } from '@/tools/formCheck';
import { moneyInt, moneyComplete } from '@/tools/money';
import Clipboard from 'clipboard';
import { priceFilter } from '@/tools/formCheck';
import { checkTax } from '@/tools/formCheck';

import PayChannel from '../components/form-items/pay-channel.vue';

const checkTransmitList = (rule, value, callback) => {
  let error = false;
  value.forEach(item => {
    !item && (error = true);
  });
  if (error) {
    callback(new Error('不能为空'));
  } else {
    callback();
  }
};

export default {
  mixins: [btLoading, makeSureMixin, hasIndustry, ocu],
  components: {
    Reviewer,
    UploadImgOne,
    GenerateImage,
    submitVerifyBtn,
    submitResult,
    dicSelect,
    TmExecuteNameRule,
    submitVerifyAndNextBtn,
    TmTargetNameRule,
    PayChannel
  },
  data() {
    return {
      holidayIsShow: '', //是否展示假期设置
      penetratingDisplay: '', //穿透显示，协定服务、数字问卷、数字拜访，可配置、调研、数字专区
      addEditMixin_auditList: [],
      addEditMixin_backgroundList: backgroundList,
      addEditMixin_channelWebUrl: '', //  数字专区 数字问卷 数字推广
      fileList: [],
      isBatch: true, //是否为批量导入
      priceFlag: false, //价格是否可编辑
      // 共有的字段
      ruleForm: {
        isNeedCertification: 0,
        authType: '', // 认证方案, 数字专区、病例征集、可配、调研、数字问卷无
        auditStatus: '',

        bgUrl: '',
        bgUrlSource: 1, // 封面图选择方式

        csoPrice: '',
        channelId: '',
        channelEditorType: 2, // 默认服务商编辑
        contractScale: 0, // 税率

        enterpriseId: '',

        id: this.projectId,
        introduction: '',
        isCPicRepeat: '',

        oldBgUrl: '',

        price: '',
        projectType: this.projectType, // 1学术拜访  2 OTC巡访  3 科室会  4 患教会 5 助手调查问卷  6 专区  7医生调查问卷  8病例
        projectStatus: 0,
        projectName: '',
        projectBackground: '',
        projectDesensitizationRule: 2, // 脱敏规则

        taskSum: '',
        taskValidDay: '', // 任务周期

        isOrderAudit: 0 // 订单支付是否需要审核
      },
      // 共有的校验
      rules: {
        projectDesensitizationRule: [
          {
            required: true,
            message: '请选择脱敏规则',
            trigger: 'blur'
          }
        ],
        introduction: [
          {
            max: 200,
            required: true,
            message: '请填写项目简介，最多200个字符',
            trigger: 'blur'
          }
        ],
        authType: [
          {
            required: true,
            message: '请选择认证方案',
            trigger: 'blur'
          }
        ],
        projectBackground: [
          {
            required: true,
            message: '请选择背景',
            trigger: 'blur'
          }
        ],
        isCPicRepeat: [
          {
            required: true,
            message: '请选择C端图片是否查重',
            trigger: 'blur'
          }
        ],
        isAllowHoliday: [
          {
            required: true,
            message: '是否允许法定节假日执行项目',
            trigger: 'change'
          }
        ],
        csoPrice: [
          {
            required: true,
            validator: priceFilter,
            trigger: 'blur'
          }
        ],
        price: [
          {
            required: true,
            validator: priceFilter,
            trigger: 'blur'
          }
        ],
        contractScale: [
          {
            required: true,
            validator: checkTax,
            trigger: 'blur'
          }
        ],
        taskSum: [
          {
            required: true,
            message: '甲方未填写总任务量',
            trigger: 'blur'
          }
        ],
        enterpriseId: [
          {
            required: true,
            message: '请选择企业',
            trigger: 'blur'
          }
        ],
        transmitList: [
          {
            required: true,
            validator: checkTransmitList,
            trigger: 'blur'
          }
        ],
        feedbackList: [
          {
            required: true,
            validator: checkTransmitList,
            trigger: 'blur'
          }
        ],
        // 数字拜访
        feedbacks: [
          {
            required: true,
            validator: checkTransmitList,
            trigger: 'blur'
          }
        ],
        projectName: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ],
        bgUrl: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'blur'
          }
        ],
        commonName: [
          {
            required: true,
            message: '请输入产品名称',
            trigger: 'blur'
          }
        ],
        jixing: [
          {
            required: true,
            message: '请输入剂型',
            trigger: 'blur'
          }
        ],
        guige: [
          {
            required: true,
            message: '请输入规格',
            trigger: 'blur'
          }
        ],
        approvalNumber: [
          {
            required: true,
            message: '请输入国药准字号',
            trigger: 'blur'
          }
        ],
        // 数字拜访校验不一致
        channelId: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.ruleForm.channelEditorType === 2 && !value) {
                callback(new Error('请选择关联专区'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      // 项目再次编辑审核
      addEditMixin_tXcxProjectUpdate: {
        introductionAuditStatus: 0, // 项目简介状态  1 审核中 2 审核通过 3 审核未通过
        auditRemark: '',
        auditApplyDt: '', // 提交审核时间
        createDt: '', // 创建时间
        auditDt: '', // 审核时间
        auditUserName: '' // 审核人
      },
      addEditMixin_backups: {}, // 用于备份修改前数据
      addEditMixin_isAginEdit: false, // true再次修改
      // 数字问卷，答题方式
      addEditMixin_answerModeOptions: [
        {
          type: 1,
          value: '自答'
        },
        {
          type: 2,
          value: '分享'
        }
      ],
      // 所有场景都会用到的 inputform 项
      addEditMixin_formItems: [
        {
          label: '任务有效期：',
          prop: 'taskValidDay',
          disabled: this.addEditMixin_disbaled,
          component: 'el-input',
          placeholder: '默认为180天',
          suffix: '天',
          // type: 'number',
          content: `                    
                    1.自然人提交任务记录日期与您提交审核日期的时间差.
                    <br />
                    2.超过有效期任务将不能提交给工业
                    <br />
                    3.有效期最长不可超过180个自然日
                    <br />
                    4.审核通过后将不可修改`,
          rule: [
            {
              required: true,
              message: '请输入 5-180 内的天数',
              trigger: 'blur',
              validator: (rule, value, cb) => {
                const exp = /^[1-9]\d*$/;
                if (!value) {
                  cb(new Error('任务有效期必填'));
                } else if (value < 5 || value > 180) {
                  cb(new Error('请输入 5-180 内的天数'));
                } else if (!exp.test(value + '') || /\D/g.test(value + '')) {
                  cb(new Error('格式错误'));
                } else {
                  cb();
                }
              }
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState({
      addEditMixin_homeProject: state => state.homeProject,
      // 方便之前数据使用
      projectType: state => state.homeProject.projectType,
      projectId: state => state.homeProject.id,
      addEditMixin_projectTypeName: state => {
        let target = state.homeProject.projectTypeName;
        return target.slice(0, -4);
      },
      homeProject: state => state.homeProject
    }),
    projectTypeName() {
      return this.addEditMixin_homeProject.projectTypeName;
    },
    addEditMixin_repeatFormItemEnabled() {
      return ![6, 17].includes(this.projectType);
    },
    // 项目是否可编辑 1：审核中 3：审核通过
    addEditMixin_disbaled() {
      const { auditStatus, projectStatus } = this.ruleForm;
      return [1, 3].includes(auditStatus) || projectStatus >= 2;
    },
    // 审核中
    addEditMixin_inReview() {
      this.ruleForm.auditStatus === 1 ||
        this.addEditMixin_tXcxProjectUpdate.introductionAuditStatus === 1;
    },
    // 项目简介是否可编辑。 审核中|| 项目不可操作 && 不处于再次编辑
    addEditMixin_introductionDisbaled() {
      return (
        this.addEditMixin_inReview ||
        (this.addEditMixin_disbaled && !this.addEditMixin_isAginEdit)
      );
    },
    // 显示保存提交，并不显示再次编辑
    addEditMixin_showSaveBtn() {
      return this.ruleForm.auditStatus !== 3;
    },
    // 显示再次编辑
    addEditMixin_aginEditBtnDisabled() {
      return this.addEditMixin_tXcxProjectUpdate.introductionAuditStatus === 1;
    },
    // 显示再次编辑
    addEditMixin_showAginEditBtn() {
      return !this.addEditMixin_isAginEdit && !this.addEditMixin_showSaveBtn;
    },
    // 显示再次编辑中保存按钮
    addEditMixin_showAginSaveBtn() {
      return this.addEditMixin_isAginEdit && !this.addEditMixin_showSaveBtn;
    }
  },
  methods: {
    // 是否需要执行人上传资质证明组件返回的数据
    selectOptionsDataEvent(data) {
      this.ruleForm.certificationClassifyLists = data;
    },
    // 根据不同场景处理特殊提交字段
    differentiationSubmitData() {
      // 数字拜访
      if (this.projectType === 17) {
        const feedbackList = [];
        for (let item of this.ruleForm.feedbacks) {
          feedbackList.push(item.feedback);
        }
        return {
          feedbackList
        };
      }
      return {};
    },
    // 复制专区链接，场景：数字专区 数字拜访 数字问卷 可配 调研
    addEditMixin_copy() {
      const clipboard = new Clipboard('.copyBtn');
      clipboard.on('success', () => {
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$message({
          message: '复制失败',
          type: 'warning'
        });
        clipboard.destroy();
      });
    },
    // 保存选择后的专区，场景： 数字专区、数字拜访
    addEditMixin_saveChannelId({ id }) {
      this.ruleForm.channelId = id;
      this.$refs.ruleForm.validateField('channelId');
      this.addEditMixin_setChannelUrl(id);
    },
    // 设置【关联推广专区】由哪方设置。场景： 数字专区、数字拜访、数字问卷
    addEditMixin_setChannelUrl(channelId = '') {
      if (!channelId) {
        this.addEditMixin_channelWebUrl = '';
        return;
      }
      if (this.projectType === 21) {
        this.addEditMixin_channelWebUrl = `https:${process.env.VUE_APP_WEBVIEW}/v3/index.html#/digital-questionnaire/home?platformType=oss&projectId=${this.projectId}`;
        return;
      }
      this.addEditMixin_channelWebUrl = `https:${this.$Config.webViewUrl}${this.$Config.webPath}/zoneHome?zone_id=${channelId}&fromcode=web&platform=web`;
    },
    // 封面图上传后赋值
    addEditMixin_finishUpload(v) {
      this.ruleForm.bgUrl = v;
    },
    // 更改封面图上传方式
    addEditMixin_changeBgType(v) {
      this.ruleForm.bgUrlSource = v;
    },
    // 背景需求校验
    addEditMixin_validateBackground() {
      this.$refs.ruleForm.validateField('projectBackground', () => {});
    },

    /**
     * @description: 添加/删除 传递/反馈信息
     * @param {number | string} number 1传递信息 2反馈信息 string修改字段
     * @param {number} index 有值则删除，无则添加
     */
    addEditMixin_editTransmitList(type, index) {
      const field =
        typeof type === 'number'
          ? { 1: 'transmitList', 2: 'feedbackList' }[type]
          : type;

      if (index !== void 0) {
        this.ruleForm[field].splice(index, 1);
        return;
      }
      if (type === 'feedbacks') {
        this.ruleForm.feedbacks.push({
          feedback: '',
          isOther: 0
        });
      } else {
        this.ruleForm[field].push('');
      }
    },

    // 审核提交。可配、问卷覆盖
    addEditMixin_finishSubmit(type, noAutoReload = false) {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.$confirm(
              this.hasIndustry
                ? '请您确认提交当前信息至后台审核，审核通过且待甲方确认无误后您将可以继续执行项目。'
                : '请您提交当前信息至后台审核，审核通过后您将可以继续执行项目。',
              '提示',
              {
                confirmButtonText: '确认提交',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                projectV2
                  .submitProjectAudit({
                    ...this.ruleForm,
                    csoPrice: moneyComplete(this.ruleForm.csoPrice),
                    price: moneyComplete(this.ruleForm.price),
                    type: type,
                    ...this.differentiationSubmitData()
                  })
                  .then(() => {
                    resolve('submit_success');
                    this.$message({
                      type: 'success',
                      message: '已提交审核',
                      onClose: function() {
                        !noAutoReload && window.location.reload();
                      }
                    });
                  })
                  .catch(() => {
                    reject('submit_error');
                  });
              })
              .catch(() => {
                reject('submit_error');
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    },
    // 提交审核：修改项目，目前只可以修改项目简介
    async addEditMixin_confirmEditProject(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let cbEvent = async () => {
            await projectV2.introductionEdit({
              id: this.ruleForm.id,
              introduction: this.ruleForm.introduction
            });
            sessionStorage.removeItem(`${this.ruleForm.id}-detail`);
            window.location.reload();
          };
          if (this.priceFlag == false) {
            makeSure(cbEvent);
          } else {
            cbEvent();
          }
        } else {
          return false;
        }
      });
    },

    // 保存。可配、问卷覆盖
    addEditMixin_submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          delete this.ruleForm['certificationClassifyList'];
          let cbEvent = () => {
            projectV2
              .addUpdateProjectV2({
                ...this.ruleForm,
                csoPrice: moneyComplete(this.ruleForm.csoPrice),
                price: moneyComplete(this.ruleForm.price),
                ...this.differentiationSubmitData()
              })
              .then(() => {
                this.$notify({
                  title: '成功',
                  message: '保存成功',
                  type: 'success'
                });
                this.$emit('resetRuleForm', this.ruleForm);
                // this.resetForm();
              });
          };
          if (this.priceFlag == false) {
            this.makeSureEvent(cbEvent);
          } else {
            cbEvent();
          }
        } else {
          return false;
        }
      });
    },
    // 初始项目数据。接口、入参一致，每个场景内的字段整理不一致
    async addEditMixin_init() {
      if (this.$route.query.id) {
        const { pdata } = await projectV2.loadProjectV2({
          id: this.projectId,
          projectType: this.projectType
        });
        const {
          taskSumCount,
          finishSumCount,
          tXcxProject,
          tXcxProjectUpdate,
          auditList
        } = pdata;
        this.penetratingDisplay = tXcxProject.finalGongyeId;
        this.holidayIsShow = tXcxProject.holidayIsShow;
        // 图片查重设置默认值。需要重复图片的场景在view form里设置
        if (
          'isCPicRepeat' in this.ruleForm &&
          ![0, 1].includes(+this.ruleForm.isCPicRepeat)
        ) {
          this.ruleForm.isCPicRepeat = 1;
        }
        this.addEditMixin_auditList = auditList;
        // this.priceFlag = tXcxProject.csoPrice ? true : false;
        tXcxProject.price = moneyInt(tXcxProject.price);
        tXcxProject.csoPrice = moneyInt(tXcxProject.csoPrice);
        // 项目描述审核
        this.addEditMixin_setIntroductionAuditStatusToAuditList(
          tXcxProjectUpdate
        );
        // 税率，优先使用this.ruleForm.contractScale，用于特殊场景税率写死
        tXcxProject.contractScale =
          this.ruleForm.contractScale || tXcxProject.contractScale || 0;
        // 赋值并解决el-select的label不显示bug，需要深拷贝一下ruleForm
        this.ruleForm = {
          ...this.ruleForm,
          ...tXcxProject,
          taskSumCount,
          finishSumCount
        };
        return Promise.resolve(pdata);
      }
      return Promise.reject();
    },
    // 修改项目，目前只可以修改项目简介
    async addEditMixin_cancelEditProject() {
      this.ruleForm = deepClone(this.addEditMixin_backups);
      this.addEditMixin_isAginEdit = false;
    },
    // 再次编辑
    async addEditMixin_onAginEditProject() {
      this.addEditMixin_backups = deepClone(this.ruleForm);
      this.addEditMixin_isAginEdit = true;
    },
    // 项目简介状态转为统一的审核状态，项目简介审核必在项目审核通过后。
    addEditMixin_setIntroductionAuditStatusToAuditList(tXcxProjectUpdate) {
      tXcxProjectUpdate &&
        (this.addEditMixin_tXcxProjectUpdate = tXcxProjectUpdate);
      let introductionAuditStatusMap = {
        0: 0,
        1: 1,
        2: 3,
        3: 2
      };
      let {
        introductionAuditStatus,
        auditRemark,
        auditApplyDt,
        auditDt
      } = this.addEditMixin_tXcxProjectUpdate;

      introductionAuditStatus =
        introductionAuditStatusMap[introductionAuditStatus];
      if (introductionAuditStatus) {
        // 倒叙，最新的插入顶层
        this.addEditMixin_auditList.unshift({
          auditStatus: introductionAuditStatus,
          auditRemark: auditRemark,
          createDt: auditApplyDt,
          auditDt: auditDt
        });
      }
    }
  },
  watch: {
    '$route.query.id': {
      handler() {
        (this.$options.created || []).forEach(fn => fn.call(this));
      }
    },
    'ruleForm.taxCollectionPattern': {
      handler(newV) {
        if (newV == 9) {
          // 工具类型项目
          ['csoPrice', 'productPrice', 'price'].forEach(item => {
            if (
              Array.isArray(this.rules[item]) &&
              Object.prototype.toString.call(this.rules[item][0]) ===
                '[object Object]'
            ) {
              this.rules[item][0].validator = priceFilterForTools;
            }
          });
        }
      },
      deep: true
    }
  },

  created() {
    this.formItems.forEach(ele => {
      this.ruleForm[ele.prop] = '';
      this.rules[ele.prop] = ele.rule;
    });
    this.$nextTick(() => {
      // 园区个体删除职业认证
      if (this.addEditMixin_homeProject.userEnterpriseType === 3) {
        const chilren = this.$refs.ruleForm.$children;
        const rules = this.$refs.ruleForm.rules;
        Object.keys(rules).forEach(r => {
          if (r === 'isOccupationAuth') {
            delete rules.isOccupationAuth;
          }
        });
        for (let i = 0; i < chilren.length; i++) {
          let child = chilren[i];
          if (child.$options.name === 'ElFormItem') {
            // 职业认证字段
            if (child.$options.propsData.prop === 'isOccupationAuth') {
              // 隐藏
              child.$el.style.display = 'none';
            }
          }
        }
      }
    });
  }
};
